import { render } from "./ProjectForm.vue?vue&type=template&id=4c92e640"
import script from "./ProjectForm.vue?vue&type=script&lang=js"
export * from "./ProjectForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__